import { Box, Grid, IconButton, Modal, Typography } from "@mui/material";
import { ErrorState } from "../types/mint";
import isNil from "lodash/isNil";
import { ErrorType } from "../lib/mint";
import styles from "../styles/MintErrorModal.module.css";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

interface Props {
  errorState: ErrorState;
  handleClose: any;
}

const ERROR_MESSAGES = {
  [ErrorType.PRICE_MISMATCH]: [
    "Invalid Price",
    "This price is invalid. Please refresh the page and try again.",
  ],
  [ErrorType.INSUFFICIENT_FUNDS]: [
    "Insufficient funds",
    "Please load your wallet with ETH and try again.",
  ],
  [ErrorType.NOT_ON_WHITELIST]: [
    "Sorry, you’re not on the whitelist.",
    "You need to be on the whitelist to mint. You'll have the opportunity to mint with everyone else when public minting opens. See the mint timeline.",
  ],
  [ErrorType.MAX_MINT_ALLOCATION]: [
    "You've already minted the maximum number of NFTs for this wallet",
    "That’s the maximum number of The Dark Horse NFTs allowed for one wallet.",
  ],
  [ErrorType.GENERIC_ERROR]: [
    "An error occurred",
    "An unexpected error occurred. Please try again later.",
  ],
  [ErrorType.USER_REJECTED_SIGN]: [
    "Signature is required",
    "Validating your wallet is required. Please provide signature in order to mint.",
  ],
  [ErrorType.USER_REJECTED_TXN]: [
    "Transaction cancelled",
    "You cancelled the transaction. Please accept the transaction in order to mint.",
  ],
};

const MintErrorModal = ({ errorState, handleClose }: Props) => {
  if (isNil(errorState.type)) {
    return null;
  }

  let [title, description] = ERROR_MESSAGES[errorState.type];

  if (!isNil(errorState.message)) {
    description = errorState.message;
  }

  return (
    <Modal
      open={true}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={styles.modalBox}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          className={styles.modalCloseButton}
        >
          <CloseIcon />
        </IconButton>
        <Grid container className={styles.contentContainer}>
          <Grid item>
            <Typography variant="h4" className={styles.title} id="modal-title">
              {title}
            </Typography>
            <Box className={styles.description} id="modal-description">
              {description}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default MintErrorModal;
